/**
 * StatusBadge Component
 *
 * A reusable status badge component with configurable color mappings.
 * Supports both queue statuses (pending, processing, etc.) and PO statuses (ACTIVE, ARCHIVED).
 */

// Default color mappings for queue/document statuses
const queueStatusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  processing: 'bg-blue-100 text-blue-800',
  extracted: 'bg-green-100 text-green-800',
  approved: 'bg-emerald-100 text-emerald-800',
  rejected: 'bg-red-100 text-red-800',
  failed: 'bg-red-100 text-red-800'
};

// Color mappings for PO statuses
const poStatusColors = {
  ACTIVE: 'bg-green-100 text-green-800',
  ARCHIVED: 'bg-gray-100 text-gray-800'
};

// Combined default colors
const defaultColors = {
  ...queueStatusColors,
  ...poStatusColors
};

/**
 * StatusBadge Component
 * @param {Object} props
 * @param {string} props.status - The status value to display
 * @param {Object} props.colors - Optional custom color mappings (status -> tailwind classes)
 * @param {string} props.variant - Optional preset variant: 'queue' | 'po' | 'default'
 * @param {string} props.className - Additional CSS classes
 */
function StatusBadge({ status, colors, variant = 'default', className = '' }) {
  // Select color mapping based on variant
  let colorMap;
  switch (variant) {
    case 'queue':
      colorMap = queueStatusColors;
      break;
    case 'po':
      colorMap = poStatusColors;
      break;
    default:
      colorMap = colors || defaultColors;
  }

  const colorClass = colorMap[status] || 'bg-gray-100 text-gray-800';
  const displayText = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

  return (
    <span className={`px-2 py-1 text-xs font-medium rounded ${colorClass} ${className}`}>
      {displayText}
    </span>
  );
}

export default StatusBadge;
export { queueStatusColors, poStatusColors, defaultColors };
